import { 
  zlbApiSopManageInspectionStatusTypeGet,
  zlbApiSopManageQueryDistrictRuleDataGet,
  zlbApiSopManageInspectionLogCountGet,
  zlbApiSopManageInspectionRiskTypeGet,
  zlbApiSopInspectionOperationInspectionPagePost,
  zlbApiSopManageQueryAllDistrictRuleGet
} from '@/api/zlbSopContent';
  
export default {
  namespace: 'operatorEventManage',
  state: {
     
  },
  
  effects: {
    // 获取巡检状态枚举
    * getStatusList ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionStatusTypeGet, payload);
      return res;
    },
  
    // 获取事件列表
    * getEventList ({ payload }, { call }) {
      const res = yield call(zlbApiSopInspectionOperationInspectionPagePost, payload);
      return res;
    },
    // 获取查询用户所拥有的区划数据权限
    * getInspectionDistrictRule ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageQueryDistrictRuleDataGet, payload);
      return res;
    },
    // 查询巡检次数
    * getInspectionLogCount ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionLogCountGet, payload);
      return res;
    },
    // 查询巡检风险类型
    * getInspectionRiskTypeList ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageInspectionRiskTypeGet, payload);
      return res;
    },
    // 获取查询用户所有区划数据权限
    * getInspectionAllDistrictRule ({ payload }, { call }) {
      const res = yield call(zlbApiSopManageQueryAllDistrictRuleGet, payload);
      return res;
    },

  },
     
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
  